// Parcel inlines JSON imports at build time, so the version string is baked
// into the bundle — no runtime `require()` and no Node `process` dependency
// (both fail the DOM-only `tsc --noEmit` strict gate).
import { version } from "../package.json";

window.addEventListener("DOMContentLoaded", () => {
  // Treat anything not served from the production host as a dev build.
  const isProduction = window.location.hostname === "www.eyevinn.se";
  const dev = isProduction ? "" : "-dev";
  const versionEl = document.querySelector<HTMLSpanElement>("#version");
  if (versionEl) {
    versionEl.textContent = version + dev;
  }
});
